import {useEffect} from 'react';
import {useLocation} from 'react-router';

import {pushVirtualPageView} from './pushVirtualPageView';
import {useStoreContext} from '~/store/useStoreContext';

export function VirtualPageViewTracker() {
  const location = useLocation();
  const [{isAuthenticated, user}] = useStoreContext();

  useEffect(() => {
    if (isAuthenticated && !user) {
      return;
    }

    pushVirtualPageView({
      pageLocation: globalThis.location.href,
      pagePath: location.pathname + location.search,
    });
  }, [
    isAuthenticated,
    location.pathname,
    location.search,
    user,
  ]);

  return null;
}
